export default __webpack_public_path__ + "static/media/YSDS_lf.26164018.svg";